import { array, object, string } from "yup";

export default object().shape({
  user: object().shape({
    firstName: string().required("is required"),
    lastName: string().required("is required"),
    emails: array()
      .of(
        object().shape({
          email: string()
            .required("is required")
            .email("must be an email")
        })
      )
      .test(
        "at-least-one-email-to-notify",
        "at least one email must be marked to receive notifications",
        emails => emails.filter(({ notify }) => notify).length > 0
      )
      .required("is required"),
    phoneNumber: string().required("is required"),
    timeZone: string().required("is required")
  }),
  role: string().required("is required"),
  reportFilters: array().when(['role'], {
    is: "Filtered",
    then: array().of(
      object().shape({
        filterKey: string().required("is required"),
        filterValues: array().of(
          string().required("is required")
        ).required("is required")
      })
    )
  })
});
